export default "__VITE_ASSET__39c0be87__"